import { useTranslation } from "react-i18next";


const BecomeSellerTwo = ({setOpenEbookModal}) => {
  const { t } = useTranslation();

  return (
    <section className="position-relative  padding-y-120 z-index-1 overflow-hidden">
     
      <div className="container container-two">
        <div className="eBook gy-4 bg-green-light padding-x-120" >
          <div className="col-lg-12">
             <div className="support-two position-relative z-1 pt-5 pb-5 pb-md-0">
              <div className="row  justify-content-center">
                <div className="col-lg-3 col-sm-7">
                  <div className="support-content ps-md-0 px-3">
                    <h3 className="support-content__titleee mb-1">
                      {t("becomeSellerTwo.title")}
                    </h3>
                    <p className="support-content__descc  font-8" style={{fontSize: '13px'}}>
                      {t("becomeSellerTwo.description.0")}
                    </p>

                    <p className="support-content__descc mb-5 font-8" style={{fontSize: '13px'}}>
                      {t("becomeSellerTwo.description.1")}
                    </p>
                    
                    < button 
                       id="become-seller-button"
                       onClick={() => setOpenEbookModal(true)}
                       className="btn btn-main btn-lg fw-300 pill">
                      
                      {
                        t("becomeSellerTwo.btn")
                      }
                    </button>
                  </div>
                </div>
                <div className="col-lg-4 d-lg-block d-none">
                  <div className="arrow-img h-100 d-flex align-items-end">
                    <img
                      src="assets/images/shapes/arrow-shape-two.png"
                      alt=""
                      className="white-version"
                    />
                    <img
                      src="assets/images/shapes/arrow-shape-two-white.png"
                      alt=""
                      className="dark-version"
                    />
                  </div>
                </div>
                <div className="col-lg-4 col-sm-5 d-sm-block d-none">
                  <div className="support-thumb text-center">
                    <img src="assets/images/thumbs/become-seller-two.webp" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </section>
  );
};

export default BecomeSellerTwo;
